const BaseComponent = () => import(/* webpackChunkName: "FactCheckBaseComponent" */ "./BaseComponent.vue");

const Home = () => import(/* webpackChunkName: "FactCheckHomeApp" */ "./Home.vue");
const Organization = () => import(/* webpackChunkName: "FactCheckOrganizationApp" */ "./Organization.vue");
const Search = () => import(/* webpackChunkName: "FactCheckSearch" */ "./Search.vue");
const ClaimSources = () => import(/* webpackChunkName: "FactCheckClaimSources" */ "./ClaimSources.vue");

// import Vue from 'vue';
import axios from 'axios';
Vue.prototype.$http = axios;

/**
 * Moment JS is a dead project and DayJS is a minimalist replacement for Moment.js, using a similar API
 * @see https://momentjs.com/docs/#/-project-status/recommendations/
 * @see https://www.npmjs.com/package/qs
 * @see https://day.js.org/docs/en/manipulate/subtract
 */
import dayjs from 'dayjs';
window.dayjs = dayjs;

/**
 * @see https://www.npmjs.com/package/jsonp#jsonpurl-opts-fn
 * @see https://github.com/axios/axios/blob/master/COOKBOOK.md#jsonp
 */
 import jsonp from 'jsonp';
window.jsonp = jsonp;

/**
 * @see https://router.vuejs.org/guide/
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);

let base_path = "/fact_check_review";
let router_base = "/";

if( typeof fc_base_path !== 'undefined' ){
    router_base = fc_base_path.replace(base_path, "")+"/";
    // base_path = fc_base_path;
}

console.log("FC BASE PATH", base_path, "ROUTER BASE", router_base);

import FactCheckMixin from '../FactCheckMixin.js';

Vue.mixin({
    mixins: [
        FactCheckMixin,
    ],
    methods: {
        clone(obj){
            return JSON.parse(JSON.stringify(obj));
        },
        strip_tags(html) {
            let div = document.createElement("div");
            div.innerHTML = html;
            return div.textContent || div.innerText || "";
        },
        number_format(number, decimals, dec_point, thousands_sep) {
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function(n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },

        /**
         * Helper function to quickly create query params for search
         * @param array $data 
         * @return string 
         */
         createQuery(data)
         {
             data = this.mergeWithBaseQuery(data);
             return this.strigifyQuery(data);
         },
 
         /**
          * Base query needed to search
          * @param array $data 
          * @return (string|int)[] 
          */
         mergeWithBaseQuery(data)
         {
             let start_date = dayjs().subtract(150, 'days').format('YYYY-MM-DD');
             let end_date   = dayjs().format('YYYY-MM-DD');
 
             let baseQuery = {
                 'dr': start_date+' to '+end_date,
                 'sd': start_date,
                 'ed': end_date,
                 'page': 1,
                 'rt': 0,
             };
 
             return Object.assign(baseQuery, data);
         },
 
         /**
          * Convert search query to string
          * @param array $data 
          * @return string 
          */
         strigifyQuery(data)
         {
             return JSON.stringify(data);
         },
    },
});

const routes = [
    {
        name: "home",
        path: base_path,
        component: Home,
        meta: {},
    },
    {
        name: "home_index",
        path: base_path+'/index.html',
        component: Home,
        meta: {},
    },
    {
        name: "organization_landing",
        path: base_path+"/organization/",
        component: Organization,
        meta: {},
    },
    {
        name: "organization_index",
        path: base_path+"/organization/index.html",
        component: Organization,
        meta: {},
    },
    {
        name: "organization_page",
        path: base_path+"/organization/:org/",
        component: Organization,
        meta: {},
    },
    {
        name: "search",
        path: base_path+"/search/",
        component: Search,
        meta: {},
    },
    {
        name: "search_index",
        path: base_path+"/search/index.html",
        component: Search,
        meta: {},
    },
    {
        name: "claim_sources",
        path: base_path+"/claim_sources/",
        component: ClaimSources,
        meta: {},
    },
    {
        name: "claim_sources_index",
        path: base_path+"/claim_sources/index.html",
        component: ClaimSources,
        meta: {},
    },
    {
        name: "claim_sources_landing",
        path: base_path+"/claim_sources/:cs/",
        component: ClaimSources,
        meta: {},
    },
    {
        name: "claim_sources_landing_index",
        path: base_path+"/claim_sources/:cs/index.html",
        component: ClaimSources,
        meta: {},
    },
];

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    saveScrollPosition: false,
    routes: routes,
    root: '/',
    base: router_base,
});

function init_app()
{
    window.fact_check_app = new Vue({
        name: "fact-check-app",
        el: "#fact-check-app",
        render: h => h(BaseComponent),
        router,
    });

    if( rcp_page_refresh_interval ){
        clearInterval(rcp_page_refresh_interval);
    }
}

export default init_app;